import { useNavigate, useLocation } from "react-router";
import { useSearchParams } from 'react-router-dom'
import { useState, useEffect } from "react";
import useAuth from "hooks/useAuth";
import axios from "axios";
import ReCAPTCHA from 'react-google-recaptcha';
import useRecaptcha from './useRecaptcha';
import './Signin.scss';
import React from 'react';
import SigninLayout from './SigninLayout';

const Signin = () => {
  const { capchaToken, recaptchaRef, handleRecaptcha } = useRecaptcha();

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const { auth, setAuth } = useAuth();
  const [email, setEmail] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordConfirmError, setPasswordConfirmError] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const [error, setError] = useState("");
  const [currentView, setCurrentView] = useState("login");
  const [searchParams, setSearchParams] = useSearchParams();
  const [formData, setFormData] = useState({
    email: searchParams.get("user"),
    validEmail: searchParams.get("validEmail"),
    code: searchParams.get("code")
  });
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if(formData.user !== null && formData.code !== null) {
      setCurrentView("resetPassword")
    }
    if(formData.validEmail !== null && formData.code !== null) {
      setCurrentView("validateEmail")
    }
  }, []);

  useEffect(() => {
    setFormData({...formData, token: capchaToken})
    console.log("reset capchaToken",capchaToken.split(-5))
    console.log(formData)
  }, [capchaToken])

  useEffect(() => {
    setFormData({
      email: searchParams.get("user"),
      validEmail: searchParams.get("validEmail"),
      code: searchParams.get("code")
    })
    setFormErrors({})
  }, [currentView])

  const API = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    withCredentials: true,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post("/auth/login", {
        email: formData.email,
        password: formData.password
      }).then((res) => {
        if (res?.data.role) {
          const role = res?.data.role;
          const name = res?.data.name;
          const token = res?.data.token;
          const timestamp = Date.now()
          localStorage.setItem('some-key', JSON.stringify({ role: `${role}`, email: `${email}`, name: `${name}`, timestamp: `${timestamp}` }));
          if (token) {
            localStorage.setItem('jwt-token', token);
          }
          setAuth({ role: `${role}`, email: `${email}`, name: `${name}` });
          setFormData({});
          navigate(from, { replace: true });
        } else {
          console.log("incorrect submission", res.message, res.data);
          setError(res.message);
        }
      })
      console.log('working');
    } catch (err) {
      if (!err?.response) {
        setError("no server response");
      } else {
        setError("login failed");
      }
    }
  };

    const initiatePasswordReset = async (e) => {
      e.preventDefault();
      setLoading(true)
      try {
        const response = await API.post("/auth/request-reset", { formData });
        if (response.data.success) {
          setResetEmail("");
          navigate(from, { replace: true });
        } else {
          setError('Failed to reset password');
        }
      } catch (err) {
        console.error('Error:', err);
        setError('Server error occured');
      } finally {
        setLoading(false);
      }
    };

    const resetPassword = async (e) => {
      e.preventDefault();
      if (!validForm()) {
        return
      }
      setLoading(true)
      try {
        const response = await API.post("/auth/reset-password", { formData });
        if (response.data.success) {
          setResetEmail("");
          navigate(from, { replace: true });
        } else {
          setError('Failed to reset password');
        }
      } catch (err) {
        console.error('Error:', err);
        setError('Server error occured');
      } finally {
        setLoading(false);
      }
    }

    const validateEmail = async (e) => {
      e.preventDefault();
      console.log(formData)
      setLoading(true)
      try {
        const response = await API.post("/auth/validate-email", { formData });
        if (response.data.success) {
          navigate(from, { replace: true });
        } else {
          setError('Failed to validate email');
        }
      } catch (err) {
        console.error('Error:', err);
        setError('Server error occured');
      } finally {
        setLoading(false);
      }
    }

    const register = async (e) => {
      e.preventDefault();
      if (!validForm()) {
        return
      }
      setLoading(true)
      try {
        const response = await API.post("/auth/register", { formData });
        if (response.data.success) {
          setResetEmail("");
          navigate(from, { replace: true });
        } else {
          setError('Failed to register user');
        }
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const backendMessage = error.response?.data?.error ?? 'Failed to register new user';
          setError(backendMessage);
        } else {
          setError("Something went wrong.");
        }
      } finally {
        setLoading(false);
        console.log("finally")
      }
    }

    const validForm = () => {
      setPasswordError()
      setPasswordConfirmError()
      if (formData.password?.length < 6) {
        setPasswordError('Password must be at least 6 characters long.');
      }
      if ((currentView === "resetPassword" || currentView === "register") && formData.password !== formData.passwordConfirm) {
        setPasswordConfirmError('Passwords do not match.');
      }
      console.log(passwordConfirmError)

      return !(passwordConfirmError || passwordError);
    }

  return (
    <SigninLayout>

          {currentView === "login" && (
          <div id="signin" className="signin-card">
            <form onSubmit={handleSubmit}>
              <h1>Sign in</h1>
              <p className="form-subtitle">Enter your username and password to log on:</p>
              <input type='email' id='email' placeholder='Email' onChange={(e) => setFormData({...formData, email: e.target.value})} required />
              <input type='password' id='password' placeholder='Password' onChange={(e) => setFormData({...formData, password: e.target.value})} autoComplete="current-password" required />
              <button className="btn btn-info btn-rounded">Sign In</button>
              <p className="error-message">{error}</p>
            </form>
            <div className="signin-links">
              <div>
                <span className="signin-links-label">Forgot your password?</span>
                <a href="#" onClick={() => setCurrentView("forgotPassword")}>Reset password</a>
              </div>
              <div>
                <span className="signin-links-label">Don't have an account?</span>
                <a href="#" onClick={() => setCurrentView("register")}>Create account</a>
              </div>
            </div>
          </div>
          )}
          {currentView === "resetPassword" && (
          <div id="reset-password" className="signin-card">
            <form onSubmit={resetPassword}>
              <h1>Reset password</h1>
              <div className="field-group">
                <span className="field-group-label">New password</span>
                <input type='password' id='new-password' placeholder='Enter new password' onChange={(e) => setFormData({...formData, password: e.target.value})} required />
                <input type='password' id='new-password-repeated' placeholder='Repeat new password' onChange={(e) => setFormData({...formData, passwordConfirm: e.target.value})} required />
              </div>
              <ReCAPTCHA ref={recaptchaRef} sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} onChange={handleRecaptcha} />
              <button className="btn btn-info btn-rounded" disabled={!capchaToken || !formData.password || !formData.passwordConfirm || formData.password !== formData.passwordConfirm}>Submit</button>
              <p className="error-message">{error}</p>
            </form>
            <div className="signin-links">
              <div>
                <span className="signin-links-label">Don't have an account?</span>
                <a href="#" onClick={() => setCurrentView("register")}>Create account</a>
              </div>
            </div>
          </div>
          )}
          {currentView === "validateEmail" && (
          <div id="validate-email" className="signin-card">
            <form onSubmit={validateEmail}>
              <h1>Validate Email</h1>
              <p>Click below to confirm your email address.</p>
              <ReCAPTCHA ref={recaptchaRef} sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} onChange={handleRecaptcha} />
              <button className="btn btn-info btn-rounded" disabled={!capchaToken}>Validate Email</button>
              <p className="error-message">{error}</p>
            </form>
          </div>
          )}
          {currentView === "forgotPassword" && (
          <div id="forgotPassword" className="signin-card">
            <form onSubmit={initiatePasswordReset}>
              <h1>Forgot password?</h1>
              <p className="form-subtitle">Enter your e-mail address below to reset your password.</p>
              <input type='email' id='reset-email' placeholder='Email' onChange={(e) => setFormData({...formData, email: e.target.value})} required />
              <button className="btn btn-info btn-rounded" disabled={!formData.email}>Submit</button>
              <p className="error-message">{error}</p>
            </form>
            <div className="signin-links">
              <div>
                <span className="signin-links-label">Remembered your password?</span>
                <a href="#" onClick={() => setCurrentView("login")}>Back to Sign in</a>
              </div>
            </div>
          </div>
          )}
          {currentView === "register" && (
          <div id="register" className="signin-card">
            <form onSubmit={register}>
              <h1>Create account</h1>
              <p className="form-subtitle">Submit the form below to create an account.</p>
              <input type='email' id='email' placeholder='Email' onChange={(e) => setFormData({...formData, email: e.target.value})} required />
              <div className="field-group">
                <span className="field-group-label">Password</span>
                <input type='password' id='password' placeholder='Password' onChange={(e) => setFormData({...formData, password: e.target.value})} autoComplete="off" required />
                {passwordError && <p className='validation-error'>{passwordError}</p>}
                <input type='password' id='confirm_password' placeholder='Confirm Password' onChange={(e) => setFormData({...formData, passwordConfirm: e.target.value})} autoComplete="off" required />
                {passwordConfirmError && <p className='validation-error'>{passwordConfirmError}</p>}
              </div>
              <div className="field-row">
                <input type='text' id='first_name' placeholder='First Name' onChange={(e) => setFormData({...formData, firstName: e.target.value})} autoComplete="off" required />
                <input type='text' id='last_name' placeholder='Last Name' onChange={(e) => setFormData({...formData, lastName: e.target.value})} autoComplete="off" required />
              </div>
              <div className="field-row">
                <input type='text' id='company' placeholder='Company Name' onChange={(e) => setFormData({...formData, company: e.target.value})} autoComplete="off" required />
                <input type='text' id='country' placeholder='Country Name' onChange={(e) => setFormData({...formData, country: e.target.value})} autoComplete="off" required />
              </div>
              <div className="field-group">
                <span className="field-group-label">Date of birth</span>
                <input type="date" name="date_of_birth" autoComplete="off" onChange={(e) => setFormData({...formData, dateOfBirth: e.target.value})} required />
              </div>
              <ReCAPTCHA ref={recaptchaRef} sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} onChange={handleRecaptcha} />
              <button className="btn btn-info btn-rounded" disabled={!capchaToken || !formData.password || !formData.passwordConfirm}>Sign up</button>
              <p className="error-message">{error}</p>
            </form>
            <div className="signin-links">
              <div>
                <span className="signin-links-label">Already have an account?</span>
                <a href="#" onClick={() => setCurrentView("login")}>Sign in</a>
              </div>
            </div>
          </div>
          )}
    </SigninLayout>
  )
}

export default Signin;